module.exports = __webpack_public_path__ + "static/img/4.c09088f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/4.png
// module id = CCKS
// module chunks = 0